import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { motion, MotionConfig } from "motion/react";
import { SessionList } from "@/components/sessions/session-list";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { usePageTitle } from "@/hooks/use-page-title";
import { sessionQueryOptions } from "@/lib/auth";

export const Route = createFileRoute("/dashboard/user")({
  component: UserPage,
});

function UserPage() {
  usePageTitle("Profile");
  const { data: session } = useSuspenseQuery(sessionQueryOptions);
  const user = session?.user;
  const displayName = user?.name || "User";

  return (
    <MotionConfig reducedMotion="user">
      <div className="mx-auto w-full max-w-2xl space-y-8 p-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="flex items-center gap-4"
        >
          <Avatar className="ring-offset-background size-14 rounded-xl ring-2 ring-rose-500/10 ring-offset-2">
            <AvatarImage src={user?.image || undefined} alt={displayName} />
            <AvatarFallback className="font-heading rounded-xl text-lg font-semibold">
              {displayName.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0">
            <h1 className="font-heading text-balance text-xl font-bold">
              {displayName}
            </h1>
            <p className="text-muted-foreground truncate text-sm">
              {user?.discordUsername ? `@${user.discordUsername}` : user?.email}
            </p>
          </div>
        </motion.div>

        <SessionList />
      </div>
    </MotionConfig>
  );
}
